import React, { useEffect, useState, Suspense, lazy } from "react";
import { BrowserRouter as Router, Switch, useHistory } from "react-router-dom";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";

// import AppRoute from './routes/AppRoute';
import AuthenticationRoute from "./routes/AuthenticationRoute";
import ProtectedRoutes from "./routes/ProtectedRoutes";
import Analytics from "analytics";
import googleAnalytics from "@analytics/google-analytics";

const AppRoute = lazy(() => import("./routes/AppRoute"));

import { Provider } from "react-redux";

import store from "./store";

const App = () => {
  const analytics = Analytics({
    app: "awesome-app",
    plugins: [
      googleAnalytics({
        measurementIds: ["G-KDEQQ04Z37"],
      }),
    ],
  });
  analytics.page();

  return (
    <>
      <PayPalScriptProvider
        options={{
          clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID,
          currency: "AUD",
          intent: "capture",
          locale: "en_AU",
          "disable-funding": "card",
        }}
      >
        <Provider store={store}>
          <Router>
            <Switch>
              <ProtectedRoutes path="/user" />
              <AuthenticationRoute path="/auth" />
              <Suspense fallback={<></>}>
                <AppRoute path="/" />
              </Suspense>
            </Switch>
          </Router>
        </Provider>
      </PayPalScriptProvider>
    </>
  );
};

export default App;
